import { useApplication } from 'src/containers/application';
import { IApplicationContext } from 'src/containers/application/ApplicationContext';

export function useKitTypeConcentrationLimits(
  ...args: Parameters<IApplicationContext['getConcentrationLimitsByKitType']>
) {
  const { getConcentrationLimitsByKitType } = useApplication();
  return getConcentrationLimitsByKitType(...args);
}
